import { combineReducers } from "redux";
import AwardsReducer from './awardsReducer'
export default combineReducers({
    AwardsReducer
})